import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';

export const LayoutSplash = Styled.section`
  max-width: 50em;
  margin: 6vh auto 3em;
  padding: 1em 1em 0;
  text-align: center;

  ${media.small`
    padding: 1em 0 0;
  `}

  * {
    text-align: center;
  }
`;

LayoutSplash.displayName = 'LayoutSplash';

export default LayoutSplash;
